import React, { useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { logout } from "../../redux/features/authSlice";
import { ROLES } from "../../constansts/Roles";
import EmptyModal from "./EmptyModal";

const PAGE_META = {
   "/dashboard": {
      title: "Dashboard",
      subtitle: "Overview of your oil logistics operations",
   },
   "/": {
      title: "Dashboard",
      subtitle: "Overview of your oil logistics operations",
   },
};

const formatLabel = (segment = "") =>
   segment
      .replace(/-/g, " ")
      .split(" ")
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
      .join(" ");

const getInitials = (text = "") => {
   const parts = text.trim().split(/\s+/).filter(Boolean);
   if (!parts.length) return "U";
   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
   return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const getPageMeta = (pathname) => {
   if (PAGE_META[pathname]) return PAGE_META[pathname];

   const segments = pathname.split("/").filter(Boolean);
   if (!segments.length) {
      return PAGE_META["/dashboard"];
   }

   const title = formatLabel(segments[segments.length - 1]);
   const section = formatLabel(segments[0]);
   return {
      title,
      subtitle: `Manage your ${section.toLowerCase()}`,
   };
};

const Header = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const user = useSelector((state) => state?.auth?.user?.data?.user);
   const role_id = user?.role_id;
   const role_name = user?.role_name;
   const displayName =
      role_id === ROLES.driver ? "Driver" : role_name || user?.name || "User";

   const [isLogoutOpen, setIsLogoutOpen] = useState(false);
   const [searchValue, setSearchValue] = useState("");
   const pageMeta = useMemo(() => getPageMeta(location.pathname), [location.pathname]);

   const handleLogout = () => {
      dispatch(logout());
   };

   return (
      <>
         <nav className="main-header navbar navbar-expand navbar-white navbar-light oil-header">
            <div className="oil-header__left">
               <a
                  className="oil-header__menu-btn"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  aria-label="Toggle sidebar"
               >
                  <i className="fas fa-bars" />
               </a>
               <div className="oil-header__title-block">
                  <h1 className="oil-header__title">{pageMeta.title}</h1>
                  <p className="oil-header__subtitle">{pageMeta.subtitle}</p>
               </div>
            </div>

            <div className="oil-header__right">
               <div className="oil-header__search">
                  <i className="fas fa-search oil-header__search-icon" />
                  <input
                     type="search"
                     className="oil-header__search-input"
                     placeholder="Search here..."
                     value={searchValue}
                     onChange={(e) => setSearchValue(e.target.value)}
                     aria-label="Search"
                  />
               </div>

               <button
                  type="button"
                  className="oil-header__notify"
                  aria-label="Notifications"
               >
                  <i className="far fa-bell" />
                  <span className="oil-header__notify-badge">3</span>
               </button>

               <div className="nav-item dropdown oil-header__user-dropdown">
                  <a
                     className="oil-header__user"
                     data-toggle="dropdown"
                     href="#"
                     role="button"
                     aria-haspopup="true"
                     aria-expanded="false"
                  >
                     <span className="oil-header__avatar" aria-hidden="true">
                        {getInitials(displayName)}
                     </span>
                     <span className="oil-header__user-name">{displayName}</span>
                     <i className="fas fa-chevron-down oil-header__user-caret" />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right oil-header__dropdown-menu">
                     <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => setIsLogoutOpen(true)}
                     >
                        <i className="fas fa-power-off mr-2" />
                        Logout
                     </button>
                  </div>
               </div>
            </div>
         </nav>

         <EmptyModal
            showModal={isLogoutOpen}
            handleCloseModal={() => setIsLogoutOpen(false)}
         >
            <div className="d-flex flex-column align-items-center pb-3">
               <p className="h3">Are you sure you want to logout?</p>
               <div className="d-flex mt-3">
                  <button
                     className="btn btn-danger mr-3"
                     style={{ width: "120px" }}
                     onClick={handleLogout}
                  >
                     Yes
                  </button>
                  <button
                     className="btn btn-success"
                     style={{ width: "120px" }}
                     onClick={() => setIsLogoutOpen(false)}
                  >
                     No
                  </button>
               </div>
            </div>
         </EmptyModal>
      </>
   );
};

export default Header;
